module.exports = __webpack_public_path__ + "img/若依开国大典场景图v2.4a79ff34.png";